import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import {
  MdEdit,
  MdClear,
} from "react-icons/md";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import EnquiryService from "../../../Services/EnquiryService";
import Loader from "../../../Components/Loader";
import moment from "moment";
import { toast } from "react-toastify";
import { DeleteItem } from "../../../Components/Modal";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../../Function/CheckAccess";
import ReactPaginate from "react-paginate";

let currentPage1 = 1

export const EnquiryManagementCRMList = () => {
  const history = useHistory();

  const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  const [enquiryList, setEnquiryList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [searchField, setSearchField] = useState();
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);


  // useEffect(() => {p
  //   setTimeout(() => {
  //     appendHandler();
  //   }, 1000);
  //   return () => {};
  // });
   const financial= (x) => {
    return Number.parseFloat(x).toFixed(2);
  }
  const appendHandler = (event, key) => {
    // console.log(key)
    event.target.closest("tr").classList.toggle("showTr");
    let arry = [...enquiryList];

    // enquiryList.filter((item, ind) => {
    //   if (key === ind) {
    //     item.show = Boolean(!item.show)
    //   }
    // });
    // eslint-disable-next-line
    enquiryList.map((val, ind) => {
      if (key === ind) {
        val.show = Boolean(!val.show);
      }
    });

    setEnquiryList(arry);
  };

  // console.log(isRowEnable);

  useEffect(() => {
    getEnquiryItem();
    // eslint-disable-next-line
  }, [searchField, currentPage]);

  const getEnquiryItem = (cancelled = 0) => {
    let param = {
      quote_status: "INQUIRY",
      cancelled: cancelled,
      page: currentPage, limit: pagination.limit 
    };
    if (searchField) {
      param["search"] = searchField;
    }
    EnquiryService.getEnquiryapi(param).then((result) => {
      if (result.status === true) {
        setPagination({ ...pagination, ...result.pagination });
        setLoader(false);

        let quoteArry = [];
        // eslint-disable-next-line
        result.data.map((val) => {
          val.show = false;

          quoteArry.push(val);
        });

        setEnquiryList(result.data);
      } else {
        setLoader(false);
      }
    });
  };

  const onModalSubmit = () => {
    let deleteData = {
      quote_token: openModal,
    };
    // console.log("deleteData ===> ", deleteData);
    EnquiryService.cancelEnquiry(deleteData).then((res) => {
      if (res.status === true) {
        getEnquiryItem(currentPage);
        toast.success("Cancelled Successfully")
        setOpenModal(false)
      } else {
        toast.error(res.message)
        setOpenModal(false)
      }
    })
  };


  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };



  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-3 flex-row">
              
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search By Name/Phone/City"
                  onChange={(e) => setSearchField(e.target.value)}
                  value={searchField}
                />
              </div>


              <div className="col-9 flex-row">
            <div className="d-flex justify-content-end w-100">
            {
              (CheckAccess(411,"add") ||  user_type === "SUPERADMIN" )&& 
              <button
                className="btn btn-primary w-sm waves-effect waves-light mx-3"
                onClick={() => history.push("add-enquiry")}
              >
                New Enquiry
              </button>
            }

              <button
                className="btn btn-warning w-sm waves-effect waves-light mx-3"
                onClick={() => getEnquiryItem(0)}
              >
                Show Enquiry
              </button>

              <button
                className="btn btn-warning w-sm waves-effect waves-light mx-3"
                onClick={() => getEnquiryItem(1)}
              >
                Show Cancelled Enquiry
              </button>
            </div>

              </div>


              
            </div>

            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th rowSpan="2">#</th>
                    <th rowSpan="2">Enquiery ID / <br />
                      Quotation No.
                    </th>
                    <th rowSpan="2">
                      Customer <br /> Name
                    </th>
                    <th rowSpan="2"> Mobile No.</th>
                    <th rowSpan="2">Inquiry Date</th>
                    {/* <th rowSpan="2">
                      Quotation <br /> No.
                    </th> */}
                    <th rowSpan="2">
                      Retailer <br /> Name
                    </th>
                    <th rowSpan="2">Destination</th>
                    <th colspan="3" className="splitting_tr_up">
                      Cargo Details
                    </th>
                    {/* <th rowSpan="2" className="text-center">
                      Get Quotes
                    </th> */}
                    <th rowSpan="2" className="text-center">
                      Action
                    </th>
                  </tr>
                  <tr className="splittingCol">
                    <td>
                      No. of <br /> Pkgs
                    </td>
                    <td>
                      Total <br /> Volume
                    </td>
                    <td>
                      Total <br /> Weight
                    </td>
                  </tr>
                </thead>

                <tbody>
                  {enquiryList &&
                    enquiryList.map((item, key) => {
                      let retailerNm = "NA";
                      if (item.quotes[0].referral_token_details &&
                        item.quotes[0].referral_token_details?.retailer_name) {
                        retailerNm = item.quotes[0].referral_token_details?.retailer_name;
                        retailerNm =  retailerNm ? retailerNm.substring(0, 10) : ''
                      }else {                
                        if(item.quotes[0].promo_code_details?.retailer_name){
                          retailerNm = item.quotes[0].promo_code_details?.retailer_name;
                          retailerNm = retailerNm ? retailerNm.substring(0, 10) : ''
                        }
                        // to get retailer name from general details 
                        else if(item.quotes[0].general_details?.retailer_name){
                          retailerNm = item.quotes[0].general_details?.retailer_name;
                          retailerNm = retailerNm ? retailerNm.substring(0, 10) : ''
                        }
                      }
                      let userFullNm = "NA";
                      if (item.quotes[0].user_detail) {
                        userFullNm = item.quotes[0].user_detail.user_full_name ? item.quotes[0].user_detail.user_full_name : item.quotes[0].user_detail.user_name
                        userFullNm = userFullNm ? userFullNm.substring(0, 10) : '' 
                      }


                      let cityCountry = item.quotes[0].quote_courier.length > 0
                        ? item.quotes[0].quote_courier.map((list) => {
                          return list.request_data.destination_city+ (list.request_data?.destination_country && (', '+list.request_data.destination_country) || '');
                        })
                        : item.quotes[0].quote_air.length > 0
                          ? item.quotes[0].quote_air.map((list) => {
                            return list.request_data.destination_city+ (list.request_data?.destination_country && (', '+list.request_data.destination_country) || '');
                          })
                          : item.quotes[0].quote_sea.length > 0
                            ? item.quotes[0].quote_air.map((list) => {
                              return list.request_data.destination_city+ (list.request_data?.destination_country && (', '+list.request_data.destination_country) || '');
                            })
                            : item.quotes[0].quote_land.length > 0
                              ? item.quotes[0].quote_land.map((list) => {
                                return list.request_data.destination_city+ (list.request_data?.destination_country && (', '+list.request_data.destination_country) || '');
                              })
                              : item.quotes[0].quote_land.map((list) => {
                                return list.request_data.destination_city+ (list.request_data?.destination_country && (', '+list.request_data.destination_country) || '');
                              })


                      return (
                        <>
                          <tr className="parentTr">
                            <td>
                              {
                                item.quotes.length > 1 ?
                                  <button
                                    className="btn btn-primary p-1 px-2"
                                    type="button"
                                    onClick={(event) => appendHandler(event, key)}
                                  >
                                    {item.show === false ? (
                                      <FaAngleUp />
                                    ) : (
                                      <FaAngleDown />
                                    )}{" "}
                                    {item.quotes.length}
                                  </button>
                                  :
                                  <button
                                    className="btn btn-primary p-1 px-2"
                                    type="button"

                                  >
                                    {1}
                                    {/* {item.quotes.length} */}
                                  </button>
                              }
                            </td>
                            <td>{item.quotes[0].quote_token || "NA"}</td>
                            <td>
                              {userFullNm}
                            </td>
                            <td>
                              {item.quotes[0].user_detail?.user_phone_number}
                            </td>

                            <td>
                              {moment(item.quotes[0].created_at).format(
                                "DD-MM-YYYY"
                              )}
                            </td>
                            {/* <td>{item.quotes[0].quote_token}</td> */}
                            {/* <td>NA</td> */}
                            <td >
                              {retailerNm}

                              {/* {(item.quotes[0].referral_token_details &&
                                item.quotes[0].referral_token_details.retailer_name)||
                                ("NA")} */}
                            </td>

                            <td>{cityCountry.join(",").slice(0,20)} <br /></td>

                            <td>
                              {item.quotes[0].quote_courier.length > 0
                                ? item.quotes[0].quote_courier.map((list) => {
                                  return list.request_data.number_of_packages;
                                })
                                : item.quotes[0].quote_air.length > 0
                                  ? item.quotes[0].quote_air.map((list) => {
                                    return list.request_data.number_of_packages;
                                  })
                                  : item.quotes[0].quote_sea.length > 0
                                    ? item.quotes[0].quote_air.map((list) => {
                                      return list.request_data.number_of_packages;
                                    })
                                    : item.quotes[0].quote_land.length > 0
                                      ? item.quotes[0].quote_land.map((list) => {
                                        return list.request_data.number_of_packages;
                                      })
                                      : item.quotes[0].quote_land.map((list) => {
                                        return list.request_data.number_of_packages;
                                      })}
                            </td>
                            <td>
                              {item.quotes[0].quote_courier.length > 0
                                ? item.quotes[0].quote_courier.map((list) => {
                                  return financial(list.request_data.volume);
                                  
                                })
                                : item.quotes[0].quote_air.length > 0
                                  ? item.quotes[0].quote_air.map((list) => {
                                    return financial(list.request_data.volume);
                                  })
                                  : item.quotes[0].quote_sea.length > 0
                                    ? item.quotes[0].quote_air.map((list) => {
                                      return financial(list.request_data.volume);
                                    })
                                    : item.quotes[0].quote_land.length > 0
                                      ? item.quotes[0].quote_land.map((list) => {
                                        return financial(list.request_data.volume);
                                      })
                                      : item.quotes[0].quote_land.map((list) => {
                                        return financial(list.request_data.volume);
                                      })}
                            </td>

                            <td>
                              {item.quotes[0].quote_courier.length > 0
                                ? item.quotes[0].quote_courier.map((list) => {
                                  return financial(list.request_data.weight);
                                })
                                : item.quotes[0].quote_air.length > 0
                                  ? item.quotes[0].quote_air.map((list) => {
                                    return financial(list.request_data.weight);
                                  })
                                  : item.quotes[0].quote_sea.length > 0
                                    ? item.quotes[0].quote_air.map((list) => {
                                      return financial(list.request_data.weight);
                                    })
                                    : item.quotes[0].quote_land.length > 0
                                      ? item.quotes[0].quote_land.map((list) => {
                                        return financial(list.request_data.weight);
                                      })
                                      : item.quotes[0].quote_land.map((list) => {
                                        return financial(list.request_data.weight);
                                      })}
                            </td>

                            {/* <td>
                              <button
                                type="button"
                                className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                onClick={() => history.push("/edit-quotes")}
                              >
                                Quote
                              </button>
                            </td> */}
                            <td>
                              <MdEdit
                                className="pointer"
                                color="#0323fe"
                                size="25px"
                                onClick={() =>
                                  history.push(
                                    "/edit-enquiry?id=" + item.quotes[0]._id,
                                    {quote_token: item.quotes[0]?.quote_token, quote_status:"INQUIRY"}
                                  )
                                }
                              />
                              <MdClear
                                className="pointer"
                                color="red"
                                size="25px"
                                onClick={() =>
                                  setOpenModal(item.quotes[0].quote_token)
                                }
                              />
                            </td>
                          </tr>

                          <tr>
                            <td colSpan="13">
                              <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                  <tr>
                                    <th rowSpan="2">#</th>
                                    <th rowSpan="2">Enquiry ID <br />
                                      Quotation No.
                                    </th>
                                    <th rowSpan="2">
                                      Customer <br /> Name
                                    </th>
                                    <th rowSpan="2"> Mobile No.</th>
                                    <th rowSpan="2">Inquiry Date</th>
                                    {/* <th rowSpan="2">
                                      Quotation <br /> No.
                                    </th> */}
                                    <th rowSpan="2">
                                      Retailer <br /> Name
                                    </th>
                                    <th rowSpan="2">Destination</th>
                                    <th
                                      colspan="3"
                                      className="splitting_tr_up"
                                    >
                                      Cargo Details
                                    </th>
                                    {/* <th rowSpan="2" className="text-center">
                                      Get Quotes
                                    </th> */}
                                    <th rowSpan="2" className="text-center">
                                      Action
                                    </th>
                                  </tr>
                                  <tr className="splittingCol">
                                    <td>
                                      No. of <br /> Packages
                                    </td>
                                    <td>
                                      Total <br /> Volume
                                    </td>
                                    <td>
                                      Total <br /> Weight
                                    </td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item.quotes.map((val, ind) => {
                                    return (
                                      <tr>
                                        <td>{ind + 1}</td>
                                        {/* <td>{val._id}</td> */}
                                        <td>{val.quote_token || "NA"}</td>
                                        <td>
                                          {val.user_detail?.user_full_name ||
                                            "NA"}
                                        </td>
                                        {/* <td>9340154980</td> */}
                                        <td>
                                          {val.user_detail?.user_phone_number}
                                        </td>

                                        <td>
                                          {moment(val.created_at).format(
                                            "YYYY-MM-DD"
                                          )}
                                        </td>
                                        {/* <td>{val.quote_token || "NA"}</td> */}

                                        {/* <td>NA</td> */}
                                        <td>
                                          {
                                            // get retailer name by general details 
                                              val?.referral_token_details?.retailer_name
                                            ? val?.referral_token_details?.retailer_name
                                            : val?.promo_code_details?.retailer_name
                                            ? val?.promo_code_details?.retailer_name
                                            : val?.general_details?.retailer_name
                                            ? val?.general_details?.retailer_name
                                            : 'NA'

                                            // (val.referral_token_details &&
                                            //   val.referral_token_details
                                            //     .retailer_name) || val.promo_code_details?.retailer_name?val.promo_code_details?.retailer_name:"NA"
                                            }
                                        </td>

                                        <td>
                                          {val.quote_courier.length > 0
                                            ? val.quote_courier.map(
                                              (list) => {
                                                return list.request_data
                                                  .destination_city;
                                              }
                                            )
                                            : val.quote_air.length > 0
                                              ? val.quote_air.map((list) => {
                                                return list.request_data
                                                  .destination_city;
                                              })
                                              : val.quote_sea.length > 0
                                                ? val.quote_air.map((list) => {
                                                  return list.request_data
                                                    .destination_city;
                                                })
                                                : val.quote_land.length > 0
                                                  ? val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .destination_city;
                                                  })
                                                  : val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .destination_city;
                                                  })}
                                        </td>

                                        <td>
                                          {val.quote_courier.length > 0
                                            ? val.quote_courier.map(
                                              (list) => {
                                                return list.request_data
                                                  .number_of_packages;
                                              }
                                            )
                                            : val.quote_air.length > 0
                                              ? val.quote_air.map((list) => {
                                                return list.request_data
                                                  .number_of_packages;
                                              })
                                              : val.quote_sea.length > 0
                                                ? val.quote_air.map((list) => {
                                                  return list.request_data
                                                    .number_of_packages;
                                                })
                                                : val.quote_land.length > 0
                                                  ? val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .number_of_packages;
                                                  })
                                                  : val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .number_of_packages;
                                                  })}
                                        </td>
                                        <td>
                                          {val.quote_courier.length > 0
                                            ? val.quote_courier.map(
                                              (list) => {
                                                return list.request_data
                                                  .volume;
                                              }
                                            )
                                            : val.quote_air.length > 0
                                              ? val.quote_air.map((list) => {
                                                return list.request_data
                                                  .volume;
                                              })
                                              : val.quote_sea.length > 0
                                                ? val.quote_air.map((list) => {
                                                  return list.request_data
                                                    .volume;
                                                })
                                                : val.quote_land.length > 0
                                                  ? val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .volume;
                                                  })
                                                  : val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .volume;
                                                  })}
                                        </td>

                                        <td>
                                          {val.quote_courier.length > 0
                                            ? val.quote_courier.map(
                                              (list) => {
                                                return list.request_data
                                                  .weight;
                                              }
                                            )
                                            : val.quote_air.length > 0
                                              ? val.quote_air.map((list) => {
                                                return list.request_data
                                                  .weight;
                                              })
                                              : val.quote_sea.length > 0
                                                ? val.quote_air.map((list) => {
                                                  return list.request_data
                                                    .weight;
                                                })
                                                : val.quote_land.length > 0
                                                  ? val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .weight;
                                                  })
                                                  : val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .weight;
                                                  })}
                                        </td>

                                        {/* <td>
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                            onClick={() =>
                                              history.push("/edit-quotes")
                                            }
                                          >
                                            Quote
                                          </button>
                                        </td> */}
                                        <td>
                                        {
                                           (CheckAccess(411,"edit") || user_type === "SUPERADMIN") && 
                                          <MdEdit
                                            className="pointer"
                                            onClick={() =>
                                              history.push(
                                                "/edit-enquiry?id=" + val._id,
                                                {quote_token: val?.quote_token, quote_status:"INQUIRY"}
                                                // val?.quote_token
                                              )
                                            }
                                            color="#0323fe"
                                            size="25px"
                                          />
                                        }

                                          {
                                            (val.is_cancel !== 1 && (CheckAccess(411,"delete")) ||  user_type === "SUPERADMIN") && <MdClear
                                              className="pointer"
                                              color="red"
                                              size="25px"
                                              onClick={() =>
                                                setOpenModal(val.quote_token)
                                              }
                                            />
                                          }

                                          {/* <MdDeleteForever
                                            className="pointer"
                                            color="red"
                                            size="25px"
                                            onClick={() =>
                                              setOpenModal(val.quote_token)
                                            }
                                          /> */}
                                          {/* <MdVisibility
                                            className="pointer"
                                            onClick={() =>
                                              history.push("enquiry-details")
                                            }
                                            color="#0323fe"
                                            size="25px"
                                          /> */}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </td>
                          </tr>

                        </>
                      );
                    })}
                </tbody>
              </table>
              {enquiryList && enquiryList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}

              {enquiryList &&
                enquiryList.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={(e) => onPageChangeEvent(e)}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
      <Loader isShow={loader} />
      {Boolean(openModal) && (
        <DeleteItem
          isOpen={Boolean(openModal)}
          title="Cancel Enquiry"
          message={`Are you sure want to cancel?`}
          onSubmitEvent={() => onModalSubmit()}
          handleClose={() => setOpenModal(false)}
        />
      )}
    </div>
  );
};
